module.exports = __webpack_public_path__ + "fonts/iconfont.dafa5bf1.woff";